import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID, REQUEST } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const FORWARDED_HEADERS = [
  'user-agent',
  'x-forwarded-for',
  'x-real-ip',
  'x-forwarded-proto',
] as const;

export const ssrForwardedHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const request = inject(REQUEST, { optional: true });

  if (isPlatformBrowser(platformId) || !request) {
    return next(req);
  }

  const forwardedHeaders = FORWARDED_HEADERS.reduce<Record<string, string>>((headers, headerName) => {
    const value = request.headers.get(headerName);

    if (value) {
      headers[headerName] = value;
    }

    return headers;
  }, {});

  if (Object.keys(forwardedHeaders).length === 0) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: forwardedHeaders,
    }),
  );
};
